// extracted by mini-css-extract-plugin
export var csatScore = "_mj-5";
export var header = "_mj-1";
export var panelWrapper = "_mj-2";
export var postPreview = "_mj-3";
export var rightContent = "_mj-0";
export var wrappingText = "_mj-4";